import { Component, OnInit } from '@angular/core';
import { TriviaService, WinnerInfo } from '../../_services/trivia-service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import {  mergeMap } from 'rxjs/operators';

@Component({
  templateUrl: './trivia-players.component.html',
  styleUrls: [
    '../../_shared/base.management.component.css'
  ]
})
export class TriviaPlayersComponent implements OnInit {
  players: WinnerInfo[];
  loading = false;
  triviaId = 0;
  serviceId = 0;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private triviaService: TriviaService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.loading = true;
    this.spinner.show();
    this.route.params.pipe(mergeMap(rp => {
      this.triviaId = +rp['triviaId'];
      this.serviceId = +rp['serviceId'];
      return this.triviaService.getTriviaResultPlayers(this.triviaId, +rp['serviceLogId']);
    }))
    .subscribe(p => {
          this.players = p;
          this.loading = false;
          this.spinner.hide();
        },
        (err) => {
          this.loading = false;
          this.spinner.hide();
          this.router.navigate([`/portal/trivia/`]);
        },
        () => { this.loading = false; this.spinner.hide(); }
        
    );
  }

  back() {
    this.router.navigate([`/portal/trivia/results/`, this.serviceId, this.triviaId]);
  }

}

